import React, { memo, useEffect, useMemo, useState } from 'react';
import classnames from 'classnames';
import { Button, Tree } from 'antd';
import { Droppable } from 'react-beautiful-dnd';
import { PlusCircleOutlined, DownOutlined } from '@ant-design/icons';

import useCustomScroll from 'hooks/useCustomScroll';
import { useRenderTree } from '../hook/renderTree';
import { handleRemoveTitle } from '../utils';
import WrapperCalculatorSize from 'common/components/wrapper/WrapperCalculatorSize';
import { ADD_QUERY } from '../utils/constants';

import './QueryCondition.less';
import EmptyAttribute from './EmptyAttribute';

const nameClass = 'query-conditions';

const QueryConditions = (props) => {
  useCustomScroll(`.${nameClass}`);
  const {
    viewMode,
    queryConditions,
    propertiesData,
    addQueryCondition,
    fetchEntityAttribute,
    queryConditionsId = 'query-conditions',
    entityType,
    ...restProp
  } = props;

  const { mappingTreeTitle } = useRenderTree({
    propertiesData,
    entityType,
  });

  let mappingTreeData = useMemo(
    () =>
      mappingTreeTitle({
        viewMode,
        queryConditionsId,
        queryConditions,
        addQueryCondition,
        ...restProp,
      }),
    [JSON.stringify(queryConditions), JSON.stringify(propertiesData), viewMode]
  );

  return (
    <>
      <Droppable droppableId={'query_conditions'} isCombineEnabled={true}>
        {(provided) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            className={classnames({
              'query-conditions scroller-extend': true,
            })}
            id={queryConditionsId}
          >
            {queryConditions?.children?.length > 0 ? (
              <RenderTree key={entityType} treeData={mappingTreeData} />
            ) : (
              <EmptyAttribute
                text='Query Conditions'
                onClick={() => {
                  addQueryCondition({
                    path: 'children',
                    type: ADD_QUERY.FILTER,
                  });
                }}
              />
            )}

            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </>
  );
};

export default QueryConditions;

const RenderTree = memo(({ treeData }) => {
  const [keyCollapse, setKeyCollapse] = useState([]);

  const onExpand = (key, { node }) => {
    let cloneKeyCollapse = [...keyCollapse];

    if (cloneKeyCollapse.includes(node?.key)) {
      cloneKeyCollapse = cloneKeyCollapse.filter((item) => item !== node?.key);
    } else {
      cloneKeyCollapse.push(node?.key);
    }
    setKeyCollapse(cloneKeyCollapse);
  };

  const removedTitle = handleRemoveTitle(treeData);

  useEffect(() => {
    if (treeData) setKeyCollapse(treeData?.collapseKey);
  }, [JSON.stringify(removedTitle)]);

  return (
    <WrapperCalculatorSize>
      {({ height }) => (
        <Tree
          showLine={{ showLeafIcon: false }}
          switcherIcon={<DownOutlined />}
          treeData={[treeData].slice()}
          expandedKeys={keyCollapse}
          onExpand={onExpand}
          selectable={false}
          virtual
          height={height}
        />
      )}
    </WrapperCalculatorSize>
  );
});
